<div class="success">
    <div class="success-image" svgImage [image]="'paper-plane'"></div>
</div>
